import React, { useState } from 'react';
import { useDispatch } from "react-redux";
import { closeModal, openModals } from "../../redux/modal.slice";
import ModalsEnum from '../../enums/modal.enum';
import Button from '../../components/Button';
import Tag from '../../components/Tag';
import Input from '../../components/Input';
import RadioOption from '../../components/RadioOption';
import { Activity } from '@untitledui/icons/Activity';
import { useGenerateQuizMutation, useDocumentGenerateQuizMutation } from '../../api/mutations/questions.mutation';

const GenerateYourQuizModal = ({modalData}) => {
    const dispatch = useDispatch();

    const [selectedOption, setSelectedOption] = useState('');
    const [questionCount, setQuestionCount] = useState('');
    const [error, setError] = useState('');

    const handleCloseModal = () => dispatch(closeModal());

    const { mutate } = useGenerateQuizMutation(modalData?.categoryTitle);
    const { mutate: generateDocumentQuizMutation } = useDocumentGenerateQuizMutation(modalData?.categoryTitle, modalData?.id);

    const openGenerateModal = () => {
        const count = parseInt(questionCount, 10);

        if (!selectedOption) {
            setError('Please select a quiz type.');
            return;
        }

        if (!questionCount || isNaN(count) || count < 1 || count > 20) {
            setError('Please enter a number between 1 and 20.');
            return;
        }
        setError('');

        dispatch(closeModal());
        dispatch(
            openModals({
                modalIds: [ModalsEnum.LOADING_MODAL],
                modalData: [
                    { 
                        className: 'big-modal',
                        num_questions: questionCount,
                        question_type: selectedOption,
                        categoryTitle: modalData?.categoryTitle
                    }
                ]
            })
        );

        if (modalData?.isDocument) {
            generateDocumentQuizMutation ({
                question_type: selectedOption,
                num_questions: questionCount
            });
        } else {
            mutate({
                question_type: selectedOption,
                num_questions: questionCount,
                id: modalData?.id
            });
        }
        
    };

    return (
        <>
            <div className="modal-header">
                <h3 className='mb-8'>Generate Your Quiz</h3>
                <Tag text={modalData?.categoryTitle} />
            </div>
            <div className="modal-body">
                <div className='mb-20'>
                    <RadioOption
                        id="flashcards"
                        name="quiz-option"
                        title="Flashcards"
                        text="See the question first, then flip for the answer."
                        icon={<Activity size={16} />}
                        onChange={() => setSelectedOption('flashcard')}
                    />
                    <RadioOption
                        id="mcq"
                        name="quiz-option"
                        title="MCQ (Multiple Choice Questions)"
                        text="Select the correct answer from several options."
                        icon={<Activity size={16} />}
                        onChange={() => setSelectedOption('multiple_choice')}
                    />
                    <RadioOption
                        id="shortAnswer"
                        name="quiz-option"
                        title="Short Answer"
                        text="Type your answer and get instant feedback."
                        icon={<Activity size={16} />}
                        onChange={() => setSelectedOption('short_answer')}
                    />
                </div>
                <Input
                    label="Number of Questions"
                    placeholder="Enter a number (1–20)"
                    id="questions-number"
                    value={questionCount}
                    onChange={(e) => setQuestionCount(e.target.value)}
                />
                {error && <p className="text-color-red mt-12" style={{fontSize: '12px'}}>{error}</p>}
            </div>
            <div className="modal-footer flex">
                <Button
                    text="Cancel"
                    type="outlined"
                    className="full-width mr-12"
                    onClick={handleCloseModal}
                />
                <Button
                    text="Generate Quiz"
                    className="full-width"
                    onClick={openGenerateModal}
                />
            </div>
        </>
    );
};

export default GenerateYourQuizModal;
